import { AppState } from '../index';

export const getAuthenticationState = (store: AppState) => store.authentication;
